import React, { useEffect } from "react";
import "./styles/caseStudies.css";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import ReadMore from "./ReadMore";
import { case_1 } from "../../helper/caseData";
import ReadMore_1 from "./ReadMore_1";
const CaseStudies = () => {
  const [readMore, setReadMore] = React.useState({
    readMore: false,
    type: 0,
  });

  const handleReadMore = (val) => {
    window.location.hash = val === 1 ? "#readMore1" : "#readMore2";
    setReadMore({
      readMore: true,
      type: val,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleHashChange = () => {
      if (window.location.hash === "#readMore1") {
        setReadMore({
          readMore: true,
          type: 1,
        });
      } else if (window.location.hash === "#readMore2") {
        setReadMore({
          readMore: true,
          type: 2,
        });
      } else {
        setReadMore({
          readMore: false,
          type: 0,
        });
      }
    };
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  console.log(readMore);
  return (
    <>
      {readMore.readMore && readMore.type === 1 && <ReadMore {...case_1} />}
      {readMore.readMore && readMore.type === 2 && <ReadMore_1 />}{" "}
      {!readMore.readMore && readMore.type === 0 && (
        <section className="case-section">
          <div className="container case-container">
            <p className="case-heading">Blogs</p>
            {/* <h2>Lorem ipsum dolor sit amet</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
        minim
      </p> */}
            <div className="case-content">
              <div className="case-left">
                <div className="left-case-content">
                  <img src="images/left-case.webp" alt="" />
                  <div className="sub-para-left-case">
                    <h3>{case_1.title}</h3>
                    <p>{case_1.subTitle}</p>
                  </div>
                  <div className="read-more">
                    <button
                      className="read-more-btn"
                      onClick={() => handleReadMore(1)}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
              <div className="case-right">
                <div className="left-case-content">
                  <img src="images/right-case.webp" alt="" />
                  <div className="sub-para-left-case">
                    <h3>
                      21 Proven Ways To Increase Mobile App Downloads in 2025
                    </h3>
                    <p>
                      With nearly 9 million mobile apps worldwide, the challenge
                      of standing out and increasing your app's downloads can be
                      daunting. If you've been struggling with low download
                      rates, you're probably wondering why users aren't flocking
                      to your app. To address this issue, let's explore ways to
                      increase mobile app downloads.
                    </p>
                  </div>
                  <div className="read-more">
                    <button
                      className="read-more-btn"
                      onClick={() => handleReadMore(2)}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CaseStudies;
